import { render, staticRenderFns } from "./StackQuiz.vue?vue&type=template&id=07143b01&scoped=true&"
import script from "./StackQuiz.vue?vue&type=script&lang=js&"
export * from "./StackQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07143b01",
  null
  
)

export default component.exports